import React from 'react';

import {  
  Row,
  Col
} from 'react-bootstrap';

import 'react-dropzone-uploader/dist/styles.css';
import Dropzone from 'react-dropzone-uploader';

import './Uploader.css';

import _ from 'lodash';

const Uploader = (props) => {
  const getUploadParams = ({ meta }) => { 
    // if(meta.size > 50000000){
    //   alert("Max limit to video size is 50 MB, to extend ask to help center...");
    //   return;
    // }   
    return { url:  props.uploadUrl} 
  }
 
  // called every time a file's `status` changes
  const handleChangeStatus = (attr, status) => {
    if(status==='error_file_size'){
      props.onUpload(attr,status);
      attr.remove();
    }
    if(status==='done'){
      props.onUpload(attr.xhr.responseText,attr.meta);
    }else{
      if(_.get(props,'onSubmit',false)){
        props.onSubmit(attr, status);
      }
    } 
  }

  // receives array of files that are done uploading when submit button is clicked
  //const handleSubmit = (files) => { console.log(files.map(f => f.meta)) }

  return <Row className="h-100" style={{minHeight: 150}}>
    <Col lg={12} className="text-center">
      <Dropzone
        classNames={{
          dropzone: "uploader", 
          inputLabel: "uploader-text",
          preview: "preview-wrapper",
          previewImage: "preview-image",           
          inputLabelWithFiles: "d-none",
          submitButtonContainer: "d-none"          
        }}
        inputContent={_.get(props,'instructions',"Drag/drop your file here or click and upload your file")}
        initialFiles={props.file}
        maxFiles={1}
        maxSizeBytes={_.get(props,'maxSizeBytes',50000000)}        
        multiple={false}
        canCancel={false}
        getUploadParams={getUploadParams}
        onChangeStatus={handleChangeStatus}
        accept={props.accept}
      />
    </Col>
  </Row>
}

export default Uploader;